import React, {useEffect, useRef, useState} from "react";
import {Card, Col, Form, Row, Badge, Modal, Button, InputGroup} from "react-bootstrap";
import {useFormik} from "formik";
import * as Yup from "yup";
import {FormikErrors} from 'formik';
import SimpleBar from "simplebar-react";
import {Link, useSearchParams} from "react-router-dom";
import Dropzone from "react-dropzone";
import Select from "react-select";
import {Editor} from "@tinymce/tinymce-react";
import {
    createProduct as createNewProduct,
    getProductById as onGetProductById,
    updateProduct as updateProduct,
} from "slices/product/thunk";
import {useDispatch, useSelector} from "react-redux";
import {ToastContainer} from "react-toastify";
import {useNavigate} from "react-router-dom";

const url = process.env.REACT_APP_API_URL;

interface Payment {
    price: string;
    months: string;
}

interface Attribute {
    name: string;
    attributeId: number;
    value: string;
}

export const ProductInformation = (props: any) => {
    const dispatch = useDispatch<any>();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const {categoryList, brandList, colorsList, attributeList, modelList, discountList, homeLayout, badge} = props.data;
    const productData = useSelector((state: any) => state.Product.product);

    const [addTickets, setAddTickets] = useState<boolean>(false);
    const [selectFile, setSelectFile] = useState<any>([]);
    const [edit, setEdit] = useState<boolean>(false);
    const [isEditorReady, setIsEditorReady] = useState(false);
    const [editFile, setEditFile] = useState([]);
    const [attributeArray, setAttributeArray] = useState<Attribute[]>([]);
    const [editContent, setEditContent] = useState(
        {
            name: '',
            model: {id: "", name: ""},
            productCategory: {id: "", name: ""},
            brand: {id: "", name: ""},
            color: {id: "", name: ""},
            currency: 'USD',
            count: '',
            price: '',
            productStatus: "false",
            payments: [] as Payment[],
            attributes: [] as Attribute[],
            img: '',
            disCount: {id: "", name: ""},
            collectionId: {id: "", name: ""},
            badge: "",
        }
    );

    const handleShowTickets = () => setAddTickets(true);
    const handleCloseTickets = () => setAddTickets(false);

    const editorRef = useRef<{
        getContent: () => string;
        setContent: (content: string) => void;
    } | null>(null);

    const handleEditorInit = (_evt: any, editor: any) => {
        editorRef.current = editor;
        setIsEditorReady(true);
    };
    //search
    const handleSearchData = (event: any) => {
        if (event) {
            setAttributeArray(attributeList.content.filter((search: any) => search.name.toLowerCase().includes(event.toLowerCase())));
        } else {
            setAttributeArray(attributeList.content);
        }
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            productTitle: editContent.name || '',
            model: editContent.model.id || '',
            productCategory: editContent.productCategory.id || "",
            brand: editContent.brand.id || '',
            color: editContent.color.id || '',
            currency: editContent.currency || 'USD',
            count: editContent.count || '',
            price: editContent.price || '',
            productStatus: editContent.productStatus,
            payments: editContent.payments,
            attributes: editContent.attributes || '',
            img: editContent.img || '',
            disCount: editContent.disCount?.id || "null",
            position: editContent.collectionId?.id || "null",
            badge: editContent.badge,
        },

        validationSchema: Yup.object({
            productTitle: Yup.string().required("Please Enter Your Product Name"),
            model: Yup.string().required("Please Enter Your Product Name"),
            productCategory: Yup.string().required("Please Enter Your Product Category"),
            brand: Yup.string().required("Please Enter Brand"),
            color: Yup.string().required("Please Enter Your Color"),
            currency: Yup.string().required("Please Enter Your Currency"),
            count: Yup.string().required("Please Enter Your Count"),
            price: Yup.string().required("Please Enter Your Price"),
            productStatus: Yup.string().required("Please Enter Your Product Status"),
            payments: Yup.array().of(
                Yup.object().shape({
                    price: Yup.string().required("Please Enter Price"),
                    months: Yup.string().required("Please Enter Currency"),
                })
            ),
            attributes: Yup.array().of(
                Yup.object().shape({
                    value: Yup.string().required("Please Enter Attribute"),
                })
            ),
            img: Yup.mixed().required("Please Enter Your Category Image"),
        }),

        onSubmit: async (values) => {

            const formData = new FormData();
            const data = {
                id: id,
                name: values.productTitle,
                basePrice: +values.price,
                discountId: +values.disCount,
                quantity: +values.count,
                description: editorRef.current ? editorRef.current.getContent() : "",
                categoryId: +values.productCategory,
                brandId: +values.brand,
                colorId: +values.color,
                currency: values.currency,
                isActive: values.productStatus,
                instalments: values.payments,
                attributes: values.attributes,
                modelId: +values.model,
                price: 10,
                images: editFile,
                collectionId: values.position,
                badgeIds: values.badge || null,
            }

            formData.append(
                "productDto",
                new Blob([JSON.stringify(data)], {type: "application/json"}),
                "productDto.json"
            );
            selectFile.forEach((file: any) => {
                formData.append("images", file);
            });

            if (edit) {
                const response = await dispatch(updateProduct({formData: formData, id: id}));
                console.log(response)
                if (response.payload?.id) {
                    // navigate(`/product-details/?id=${response.payload.id}`);
                }
            } else {
                let resData = await dispatch(createNewProduct(formData));
                console.log(resData);
                resData.then((response: any) => {
                    if (response.payload?.id) {
                        navigate(`/product-details/?id=${resData.payload.id}`);
                    }
                })
            }
        }
    });

    const addPayment = () => {
        formik.setValues({
            ...formik.values,
            payments: [...formik.values.payments, {price: "", months: ""}]
        });
    }

    const removePayment = (index: number) => {
        formik.setValues({
            ...formik.values,
            payments: formik.values.payments.filter((_, i) => i !== index)
        });
    }

    const deleteAttribute = (index: number) => {
        formik.setValues({
            ...formik.values,
            attributes: formik.values.attributes.filter((_, i) => i !== index)
        });
    }

    const handleClick = (item: any) => {
        formik.setValues({
            ...formik.values,
            attributes: [...formik.values.attributes, {value: "", attributeId: item.id, name: item.name}],
        });

    };
    const options = categoryList.content.map((item: any) => ({
        value: item.id,
        label: item.name,
    }));
    const optionsSelect = Array.isArray(badge)
        ? badge.map((item: any) => ({
            value: item.id,
            label: item.displayName,
        }))
        : [];

    // Helper functions
    function formatBytes(bytes: any, decimals = 2) {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }

    const handleAcceptFile = (files: any) => {
        const newImages = files?.map((file: any) => {
            return Object.assign(file, {
                priView: URL.createObjectURL(file),
                formattedSize: formatBytes(file.size),
            });
        });
        setSelectFile([...selectFile, ...newImages]);
    };

    useEffect(() => {
        if (id) {
            dispatch(onGetProductById(id));
        }
    }, [dispatch]);
    useEffect(() => {
        setAttributeArray(attributeList.content);
    }, [attributeList]);

    useEffect(() => {
        if (Object.keys(productData).length > 0 && id) {
            setEditContent((editContent: any) => ({
                ...editContent,
                name: productData.name,
                model: productData.model,
                productCategory: productData.categoryDto,
                brand: productData.brandDto,
                color: productData.color,
                currency: productData.currency,
                count: productData.quantity,
                price: productData.basePrice,
                productStatus: productData.isActive,
                payments: productData.instalments,
                attributes: productData.attributes,
                img: productData?.images[0]?.name,
                disCount: productData.discount,
                collectionId: productData.collectionDto,
                badge: Array.isArray(productData?.badges)
                    ? productData.badges.map((item: any) => item.id)
                    : [],
            }));
            setEditFile(productData.images);
            setEdit(true);
            if (isEditorReady) {
                editorRef.current?.setContent(productData.description || "<p></p>");
            }
        }
        console.log(productData);
    }, [productData, isEditorReady]);

    return (
        <React.Fragment>
            <Form autoComplete="off" onSubmit={formik.handleSubmit} className={"container-fluid m-auto"}>
                <Row>
                    <Col xxl={8}>
                        <Card>
                            <Card.Header>
                                <Card.Title as="h5" className="mb-3">Product Information:</Card.Title>
                                <hr/>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="productTitle">Product Title <span
                                                className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                id="productTitle"
                                                name="productTitle"
                                                placeholder="Enter product title"
                                                value={formik.values.productTitle}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.productTitle}/>
                                            {formik.errors.productTitle && formik.touched.productTitle ? (
                                                <Form.Control.Feedback
                                                    type="invalid">{formik.errors.productTitle}</Form.Control.Feedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="model">Models <span
                                                className="text-danger">*</span></Form.Label>
                                            <Form.Select
                                                className="form-control"
                                                name="model"
                                                id="model"
                                                value={formik.values.model}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.model}
                                            >
                                                <option value={""}>Select Model</option>
                                                {modelList.content.length > 0 && modelList.content.map((item: any, index: any) => (
                                                    <option key={index}
                                                            value={item.id}>{item.productName}</option>
                                                ))}

                                            </Form.Select>
                                            {formik.errors.model && formik.touched.model ? (
                                                <Form.Control.Feedback
                                                    type="invalid"> {formik.errors.model} </Form.Control.Feedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <label htmlFor="productCategory" className="form-label">
                                                Categories <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                id="productCategory"
                                                name="productCategory"
                                                options={options}
                                                value={options.find((opt: any) => opt.value === formik.values.productCategory) || null}
                                                onChange={(selected: any) =>
                                                    formik.setFieldValue("productCategory", selected?.value)
                                                }
                                                onBlur={() => formik.setFieldTouched("productCategory", true)}
                                                isSearchable={true}
                                                placeholder="Select Category"
                                            />

                                            {formik.errors.productCategory && formik.touched.productCategory && (
                                                <div className="text-danger">{formik.errors.productCategory}</div>
                                            )}
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="brand">Brand <span
                                                className="text-danger">*</span></Form.Label>
                                            <Form.Select
                                                className="form-control"
                                                name="brand"
                                                id="brand"
                                                value={formik.values.brand}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.brand}
                                            >

                                                <option defaultValue="">Select Brand</option>
                                                {brandList.content.length > 0 && brandList.content.map((item: any, index: any) => (
                                                    <option key={index} value={item.id}>{item.name}</option>
                                                ))}

                                            </Form.Select>
                                            {formik.errors.brand && formik.touched.brand ? (
                                                <Form.Control.Feedback
                                                    type="invalid"> {formik.errors.brand} </Form.Control.Feedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="color">
                                                Product color <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                className="form-control"
                                                name="color"
                                                id="color"
                                                value={formik.values.color}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.color}
                                            >
                                                <option defaultValue="">Select Type</option>
                                                {colorsList.content.length > 0 && colorsList.content.map((item: any, index: any) => (
                                                    <option key={index} value={item.id}>{item.name}</option>
                                                ))}

                                            </Form.Select>
                                            {formik.errors.color && formik.touched.color ? (
                                                <Form.Control.Feedback
                                                    type="invalid"> {formik.errors.color} </Form.Control.Feedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="count">
                                                Product count<span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="number"
                                                id="count"
                                                name="count"
                                                placeholder="Enter product count"
                                                value={formik.values.count}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.count}/>
                                            {formik.errors.count && formik.touched.count ? (
                                                <Form.Control.Feedback
                                                    type="invalid">{formik.errors.count}</Form.Control.Feedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Form.Label
                                                htmlFor="choices-publish-status-input">Status</Form.Label>
                                            <Form.Select
                                                id="productStatus"
                                                name="productStatus"
                                                value={formik.values.productStatus}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.productStatus}>
                                                <option value="false">No Active</option>
                                                <option value="true">Active</option>
                                            </Form.Select>
                                            {formik.errors.productStatus && formik.touched.productStatus ? (
                                                <Form.Control.Feedback
                                                    type="invalid"> {formik.errors.productStatus} </Form.Control.Feedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="disCount">
                                                Discount <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                className="form-control"
                                                name="disCount"
                                                id="disCount"
                                                value={formik.values.disCount}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            >
                                                <option defaultValue="null">No discount</option>
                                                {discountList.content.length > 0 && discountList.content.map((item: any, index: any) => (
                                                    <option key={index} value={item.id}>{item.name}</option>
                                                ))}
                                            </Form.Select>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={5}>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="currency">currency<span
                                                className="text-danger">*</span></Form.Label>
                                            <Form.Select
                                                className="form-control"
                                                name="currency"
                                                id="currency"
                                                value={formik.values.currency}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.currency}>
                                                <option defaultValue="Classified">USD</option>
                                                <option defaultValue="Simple">UZD</option>
                                            </Form.Select>
                                            {formik.errors.currency && formik.touched.currency ? (
                                                <Form.Control.Feedback
                                                    type="invalid"> {formik.errors.currency} </Form.Control.Feedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                    <Col lg={5}>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="count">
                                                Price({formik.values.currency})<span
                                                className="text-danger">*</span>
                                            </Form.Label>
                                            <InputGroup hasValidation>
                                                <InputGroup.Text id="product-price-addon">$</InputGroup.Text>
                                                <Form.Control
                                                    type="number"
                                                    id="price"
                                                    name="price"
                                                    placeholder="Enter product price"
                                                    value={formik.values.price}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    isInvalid={!!formik.errors.price}
                                                />

                                                {formik.errors.price && formik.touched.price ? (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formik.errors.price}
                                                    </Form.Control.Feedback>
                                                ) : null}
                                            </InputGroup>
                                        </div>
                                    </Col>
                                    <Col lg={2}>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="add-rastrochka">
                                                Add rastrochka<span className="text-danger">*</span>
                                            </Form.Label>
                                            <div className="btn btn-primary" onClick={addPayment}>
                                                <i className="bi bi-plus-circle align-baseline me-1"></i> Rastrochka
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                {formik.values.payments.length > 0 && formik.values.payments.map((payment: any, index) => (
                                    <Row key={index}>
                                        <Col lg={5}>
                                            <div className="mb-3">
                                                <Form.Label htmlFor={`payments[${index}].price`}>
                                                    Price ({formik.values.currency}) <span
                                                    className="text-danger">*</span>
                                                </Form.Label>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text
                                                        id="product-price-addon">$</InputGroup.Text>
                                                    <Form.Control
                                                        type="number"
                                                        id={`payments[${index}].price`}
                                                        name={`payments[${index}].price`}
                                                        placeholder="Enter rastrochka price"
                                                        value={formik.values.payments[index].price}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        isInvalid={!!(formik.errors.payments?.[index] as FormikErrors<Payment>)?.price}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {(formik.errors.payments?.[index] as FormikErrors<Payment>)?.price}
                                                    </Form.Control.Feedback>
                                                </InputGroup>
                                            </div>
                                        </Col>

                                        <Col lg={5}>
                                            <div className="mb-3">
                                                <Form.Label htmlFor={`payments[${index}].months`}>
                                                    Month <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    id={`payments[${index}].months`}
                                                    name={`payments[${index}].months`}
                                                    placeholder="Month"
                                                    value={formik.values.payments[index].months}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    isInvalid={!!(formik.errors.payments?.[index] as FormikErrors<Payment>)?.months}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {(formik.errors.payments?.[index] as FormikErrors<Payment>)?.months}
                                                </Form.Control.Feedback>
                                            </div>
                                        </Col>
                                        <Col lg={2}>
                                            <div className="mb-3">
                                                <Form.Label htmlFor="add-rastrochka">
                                                    Remove List<span className="text-danger">*</span>
                                                </Form.Label>
                                                <div className="btn btn-danger"
                                                     onClick={() => removePayment(index)}>
                                                    <i className="ph-x align-middle"></i> Remove
                                                </div>

                                            </div>
                                        </Col>

                                    </Row>
                                ))}
                            </Card.Body>
                        </Card>
                        <Card>
                            <Card.Header>
                                <div className={"d-flex align-items-start justify-content-between gap-2"}>
                                    <Card.Title as="h5" className="mb-3">Attributes:</Card.Title>
                                    <div className="btn btn-primary" onClick={handleShowTickets}>
                                        <i className="bi bi-plus-circle align-baseline me-1"></i> Attributes
                                    </div>
                                </div>
                                <hr/>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    {formik.values.attributes.length > 0 &&
                                        formik.values.attributes.map((attribute: any, index) => {
                                            const attributeErrors = formik.errors.attributes?.[index] as FormikErrors<Attribute>;
                                            return (
                                                <Col lg={4} key={index}>
                                                    <div className="mb-3">
                                                        <Form.Label htmlFor={`attributes[${index}].value`}>
                                                            {attribute.name} <span
                                                            className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            id={`attributes[${index}].value`}
                                                            name={`attributes[${index}].value`}
                                                            placeholder="Attribute"
                                                            value={formik.values.attributes[index].value}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            isInvalid={!!attributeErrors?.value}
                                                        />
                                                        {attributeErrors?.value && (
                                                            <Form.Control.Feedback type="invalid">
                                                                {attributeErrors.value}
                                                            </Form.Control.Feedback>
                                                        )}
                                                    </div>
                                                </Col>
                                            );
                                        })
                                    }
                                </Row>
                            </Card.Body>
                        </Card>
                        <Card>
                            <Card.Body>
                                <Card.Title className="mb-3">Description:</Card.Title>
                                <Editor
                                    apiKey="e5n8ww55nxsiz86j2cu32zqr4ab587l4469ol6sadb34hvtm"
                                    onInit={handleEditorInit}
                                    initialValue="<p></p>"
                                    init={{
                                        height: 500,
                                        plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table wordcount help quickbars emoticons',
                                        imagetools_cors_hosts: 'picsum.photos',
                                        menubar: 'file edit view insert format tools table help',
                                        toolbar:
                                            'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | source code | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | forecolor backcolor removeformat | fullscreen preview save | insertfile image media link anchor codesample | ltr rtl',
                                        content_style: 'body { font-family: Helvetica, Arial, sans-serif; font-size: 14px }',
                                    }}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xxl={4}>
                        <Card>
                            <Card.Header>
                                <Card.Title className="mb-3">Images, position:</Card.Title>
                                <hr/>
                            </Card.Header>
                            <Card.Body>
                                <div className="mb-3">
                                    <label htmlFor="badge" className="form-label">
                                        Badges <span className="text-danger">*</span>
                                    </label>

                                    <Select
                                        id="badge"
                                        name="badge"
                                        options={optionsSelect}
                                        isMulti
                                        value={optionsSelect.filter((opt: any) =>
                                            formik.values.badge.includes(opt.value)
                                        )}
                                        onChange={(selected: any) => {
                                            formik.setFieldValue(
                                                "badge",
                                                selected.map((opt: any) => opt.value)
                                            );
                                        }}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>

                                <div className="mb-3">
                                    <Form.Label
                                        htmlFor="position">Collection</Form.Label>
                                    <Form.Select
                                        id="position"
                                        name="position"
                                        value={formik.values.position}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isInvalid={!!formik.errors.position}>
                                        <option value={"null"}>No Collection</option>
                                        {homeLayout?.map((item: any, index: any) => (
                                            <option value={item?.id} key={index}>{item?.title}</option>
                                        ))}

                                    </Form.Select>
                                    {formik.errors.position && formik.touched.position ? (
                                        <Form.Control.Feedback
                                            type="invalid"> {formik.errors.position} </Form.Control.Feedback>
                                    ) : null}
                                </div>
                                <div className="mb-3">
                                    <Dropzone
                                        onDrop={(acceptFile: File[]) => {
                                            if (acceptFile.length > 0) {
                                                handleAcceptFile(acceptFile);
                                                formik.setFieldValue("img", acceptFile[0]);
                                            }
                                        }}
                                        accept={{"image/*": []}}
                                        multiple={true}
                                    >
                                        {(dropzoneProps: any) => {
                                            const {getRootProps, getInputProps} = dropzoneProps;
                                            return (
                                                <div className="mb-3">
                                                    <Form.Label htmlFor="product-images-input">Product
                                                        Images</Form.Label>

                                                    <div className="dropzone dz-clickable text-center">
                                                        <div
                                                            className="dz-message needsclick"
                                                            {...getRootProps()}
                                                        >
                                                            <input {...getInputProps()} name="img"
                                                                   onBlur={formik.handleBlur}/>
                                                            <div className="mb-3">
                                                                <i className="display-4 text-muted ri-upload-cloud-2-fill"/>
                                                            </div>
                                                            <h4>Drop product images here or click to upload.</h4>
                                                        </div>
                                                    </div>

                                                    {formik.errors.img && formik.touched.img && (
                                                        <Form.Control.Feedback type="invalid" className="d-block">
                                                            {formik.errors.img}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </div>
                                            );
                                        }}
                                    </Dropzone>
                                    <ul className="list-unstyled mb-0" id="dropzone-preview">
                                        {
                                            (editFile || [])?.map((file: any, index: number) => {
                                                return (
                                                    <li className="mt-2 dz-image-preview" key={index}>
                                                        <div className="border rounded">
                                                            <div className="d-flex flex-wrap gap-2 p-2">
                                                                <div className="flex-shrink-0 me-3">
                                                                    <div
                                                                        className="avatar-sm bg-light rounded p-2">
                                                                        <img
                                                                            data-dz-thumbnail=""
                                                                            className="img-fluid rounded d-block"
                                                                            src={url + file?.url}
                                                                            alt={file?.name}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="flex-grow-1">
                                                                    <div className="pt-1">
                                                                        <h5 className="fs-md mb-1"
                                                                            data-dz-name>{file?.contentType}</h5>
                                                                        <p className="fs-sm text-muted mb-0"
                                                                           data-dz-size="">
                                                                            <strong>{formatBytes(file?.size)}</strong>
                                                                        </p>
                                                                        <strong className="error text-danger"
                                                                                data-dz-errormessage></strong>
                                                                    </div>
                                                                </div>
                                                                <div className="flex-shrink-0 ms-3">
                                                                    <Button
                                                                        variant="danger"
                                                                        size="sm"
                                                                        onClick={() => {
                                                                            const newImages = [...editFile];
                                                                            newImages.splice(index, 1);
                                                                            setEditFile(newImages);
                                                                        }}
                                                                    >
                                                                        Delete</Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                );
                                            })
                                        }
                                        {
                                            (selectFile || [])?.map((file: any, index: number) => {
                                                return (
                                                    <li className="mt-2 dz-image-preview" key={index}>
                                                        <div className="border rounded">
                                                            <div className="d-flex flex-wrap gap-2 p-2">
                                                                <div className="flex-shrink-0 me-3">
                                                                    <div
                                                                        className="avatar-sm bg-light rounded p-2">
                                                                        <img data-dz-thumbnail=""
                                                                             className="img-fluid rounded d-block"
                                                                             src={file?.priView}
                                                                             alt={file?.name}/>
                                                                    </div>
                                                                </div>
                                                                <div className="flex-grow-1">
                                                                    <div className="pt-1">
                                                                        <h5 className="fs-md mb-1"
                                                                            data-dz-name>{file?.path}</h5>
                                                                        <p className="fs-sm text-muted mb-0"
                                                                           data-dz-size="">
                                                                            <strong>{file.formattedSize}</strong>
                                                                        </p>
                                                                        <strong className="error text-danger"
                                                                                data-dz-errormessage></strong>
                                                                    </div>
                                                                </div>
                                                                <div className="flex-shrink-0 ms-3">
                                                                    <Button
                                                                        variant="danger"
                                                                        size="sm"
                                                                        onClick={() => {
                                                                            const newImages = [...selectFile];
                                                                            newImages.splice(index, 1);
                                                                            setSelectFile(newImages);
                                                                        }}>Delete</Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                );
                                            })
                                        }
                                    </ul>
                                </div>
                            </Card.Body>

                            <Card.Footer>
                                <div className="hstack gap-2 justify-content-end mb-3">
                                    {edit ? "" : (
                                        <Button variant="danger"><i className="ph-x align-middle"></i> Cancel</Button>
                                    )}

                                    <Button type={"submit"} variant="primary">
                                        {edit ? "Update Product" : "Create product"}
                                    </Button>
                                </div>
                            </Card.Footer>
                        </Card>
                    </Col>

                </Row>
            </Form>

            <Modal show={addTickets} onHide={handleCloseTickets} contentClassName="border-0">
                <Modal.Header closeButton>
                    <Modal.Title as="h5" id="addTicketModalLabel">
                        Add Attributes
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={"mb-3"}>
                        <Form.Control type="text" className="search" placeholder="Search products..." onChange={(e) => handleSearchData(e.target.value)} />
                    </div>
                    <Row>
                        <div className={"d-flex align-items-center flex-wrap gap-2 mb-3"}>
                            {
                                formik.values.attributes.length > 0 && formik.values.attributes.map((value: any, index: any) => (
                                    <div key={index}>
                                        <strong>{value.name}</strong>
                                        <Badge bg="dark-subtle" text="dark" className="ms-1" onClick={() => {
                                            deleteAttribute(index)
                                        }}>
                                            <i className="bi bi-x-lg align-baseline me-1"></i>
                                        </Badge>
                                    </div>
                                ))
                            }
                        </div>

                        <SimpleBar style={{maxHeight: "300px"}}>
                            <div className="mb-1">
                                <div className="vstack gap-2 select-element">
                                    {
                                        (attributeArray || [])?.map((item: any, index: any) => {
                                            return (
                                                <div
                                                    className="d-flex align-items-center option-list border-bottom pb-2"
                                                    key={item?.id}>
                                                    <div className="flex-grow-1">
                                                        <h6 className="mb-0 d-flex align-items-center gap-2">
                                                            <span>{index + 1})</span>
                                                            <Link to="#"
                                                                  className="text-body d-block">{item?.name}</Link>
                                                        </h6>
                                                    </div>
                                                    <div className="flex-shrink-0">
                                                        <Button
                                                            variant="light"
                                                            size="sm"
                                                            onClick={() => handleClick(item)}
                                                            className="btn-action">Add</Button>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        </SimpleBar>
                    </Row>
                </Modal.Body>
            </Modal>
            <ToastContainer/>
        </React.Fragment>
    );
}

